import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Button from '@spothero/ui/button';
import DateUtils from 'utils/date';

const SpotListSearchControlsCondensed = ({
    starts,
    ends,
    isMonthly,
    title,
    onEditClick,
}) => {
    const dateTimeFormatted = DateUtils.getDateTimeSummary({
        startDateTimeObj: moment(starts),
        endDateTimeObj: moment(ends),
        isMonthly,
    });
    const dateTime = isMonthly
        ? `Starting ${dateTimeFormatted}`
        : dateTimeFormatted;

    return (
        <div className="SpotListSearchControlsCondensed">
            <div className="SpotListSearchControlsCondensed-info">
                <h3>{title}</h3>
                <p>{dateTime}</p>
            </div>
            <Button color="secondary" onClick={onEditClick}>
                Edit
            </Button>
        </div>
    );
};

SpotListSearchControlsCondensed.propTypes = {
    starts: PropTypes.string.isRequired,
    ends: PropTypes.string,
    isMonthly: PropTypes.bool,
    title: PropTypes.string,
    onEditClick: PropTypes.func.isRequired,
};

export default SpotListSearchControlsCondensed;
